<style>
.eq-editor{
    border: 1px solid #ced4da;
    border-radius: .25rem;
    font-size: 16px;
    min-height: 35px !important;
    
}
.eq-editor.xl{
    padding:5px 0px 5px 20px;
}
.eq-editor.md{
    padding:5px 0px 5px 10px;
}
.eq-editor.sm{
    padding:0px 0px 0px 10px;
}
.min-height-eq-editor{
  min-height: 35px !important;
}
.eq-editor:focus,.eq-editor:focus-within{
  outline: none !important;
  border: 1px solid #80bdff;
}
.ML__keyboard{
 z-index: 1041 !important;

}
.eq-editor .valid, .eq-editor[disabled].valid{
  border: 1px solid #28a745;
}
.eq-editor[disabled]{
  opacity: 1 !important;
  background: #f3f3f3 ;
}


</style>
<style lang="scss">
.eq-editor{
  & .valid{
    border: 1px solid #28a745;
  }
  
}
</style>
<template>
  <div>
    <math-field  
      :id="id" 
      virtual-keyboard-mode="manual" 
      :class="'eq-editor ' +size+(state == null ? '' : (state == true ? ' valid' : ' invalid'))" 
      @input="inputChanged" 
      :disabled="disabled"
    >
      {{value}}
    </math-field>
  </div>
</template>
<script>
import * as MathLive from "mathlive/dist/mathlive.min.mjs";
import 'mathlive/dist/mathlive-fonts.css'

export default {
  components:{
    // eslint-disable-next-line vue/no-unused-components
    MathLive
  },
  props: {
    id:{
      type: String
    },
    value:{
      type: String
    },
    size:{
      type: String,
      default : 'md'
    },
    disabled:{
      type: Boolean,
      default : false
    },
    state:{
      type: Boolean,
      default : null,
    }
  },
  data() {
    return {
      el:null
    };
  },
  watch:{
    value(){
      const va = document.querySelector('#'+this.id)
      va.setValue(this.value)
    },
  },
  mounted(){
    this.el = document.querySelector('#'+this.id);
  },
  methods: {
    inputChanged(ev){
      this.$emit('update:value',ev.target.value )
    }
  },
};
</script>
